import React from 'react';
// import Navigation from '../components/header/navigaton';
import Navigation from '../components/macro/header/navigaton';
// TODO: remove the previous use reference
import SkinDetailAnalysis from '../components/micro/skinDetailAnalysis/skinDetailAnalysis';
import { useLocation } from 'react-router-dom';

const SkinAnalysis = () => {
  const { state } = useLocation();
  return <SkinDetailAnalysis image={state} />;
};

export default SkinAnalysis;
